module.exports = __webpack_public_path__ + "static/media/america.a6e4e48c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/Search/america.jpg
// module id = 1128
// module chunks = 0